<template>
  <div v-if="!entries.length" class="alert alert-info">{{ $t('reporting.noDataForSelectedRange') }}</div>
  <e-chart v-else :option="fractionsPieChartOptions" autoresize />
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'FractionsPieChart',
  inject: ['companyUser'],
  props: {
    entries: {
      type: Array,
      required: true,
    },
    showLabelOnChart: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [stringUtils],
  computed: {
    fractionsSeries() {
      const self = this

      return this.entries
        .filter(item => item.count > 0)
        .map(fractionEntry => {
          if (fractionEntry.color) {
            const borderColor = this.isBright(fractionEntry.color) ? '#d8d8d8' : null

            return {
              name: fractionEntry.translations[self.companyUser.user.language],
              value: fractionEntry.count,
              itemStyle: { color: fractionEntry.color, borderColor: borderColor },
            }
          } else {
            return {
              name: fractionEntry.translations[self.companyUser.user.language],
              value: fractionEntry.count,
            }
          }
        })
    },
    label() {
      if (this.showLabelOnChart) {
        return {
          show: true,
          overflow: 'break',
          formatter: '{@2012} ({d}%)',
        }
      } else {
        return {
          show: false,
        }
      }
    },
    fractionsPieChartOptions() {
      return {
        tooltip: {
          trigger: 'item',
          formatter: `<strong>{b}:</strong><br/>{c} ${this.$t('meta.container')} ({d}%)`,
        },
        legend: {
          orient: 'horizontal',
          left: 'left',
          top: '0px',
          icon: 'circle',
          textStyle: {
            fontWeight: 'lighter',
          },
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '0',
          top: '0',
        },
        series: [
          {
            name: this.$t('meta.fraction'),
            type: 'pie',
            radius: '65%',
            center: ['50%', '50%'],
            data: this.fractionsSeries,
            label: this.label,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
    },
  },
  methods: {
    isBright(color) {
      color = color.replace('#', '')

      const r = parseInt(color.substr(0, 2), 16)
      const g = parseInt(color.substr(2, 2), 16)
      const b = parseInt(color.substr(4, 2), 16)
      const yiq = (r * 299 + g * 587 + b * 114) / 1000

      return yiq >= 186
    },
  },
}
</script>
